// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.cartActionSegment {
  display: block;
  max-width: 250px;
  border-right: 1px solid lightgray;
}

.clsSavedSearches {
  max-height: 350px;
  overflow-y: auto;
}

.clshdr {
  border-bottom: 1px solid lightgray;
  margin-bottom: 0px;
}

.cellTemplateInput {
  width: 100%;
}

.filters {
  height: 100%;
  background-color: #f5f5f6;
  padding: 0 0 180px;
}

ion-row ion-textarea {
  border: 1px solid #0099c2 !important;
  border-radius: 5px !important;
}

.searchFilters {
  margin: 0px !important;
}

.itemList {
  --background: #f5f5f6 !important;
  font-size: 14px;
  border-bottom: 1px solid #eaeaec;
}

.noPadding {
  --padding-start: 0px !important;
  --padding-end: 0px !important;
  --padding-top: 0px !important;
  --padding-bottom: 0px !important;
}

.filter {
  padding: 14px 12px 10px 20px;
  text-align: left;
  font-weight: 500;
  height: 50px;
  font-size: 13px;
}

.selectedFilter {
  --background: #fff;
  font-weight: 500;
  font-size: 14px;
  border-bottom: 1px solid #eaeaec;
}

.headTitle {
  text-align: center;
  margin-top: 0px;
  width: 100%;
}

/* =====================================================================
   Cart Actions — card-grid redesign (only the !actionType branch).
   Colours match the search action sheet; palette preserved via vars.
   ===================================================================== */
.cca-header ion-toolbar {
  --background: #fff;
  --border-width: 0 0 1px 0;
  --border-color: #eef0f1;
}

.cca-title {
  font-size: 18px;
  font-weight: 700;
  color: #2c3033;
  padding-inline: 16px;
}

.cca-close {
  --color: #6b7280;
}

.cca-content {
  --background: #fff;
}

.cca-summary {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  padding: 14px 16px 2px;
}

.cca-chip {
  border: 1px solid var(--ion-color-primary);
  color: var(--ion-color-primary);
  background: #fff;
  border-radius: 40px;
  padding: 4px 12px;
  font-size: 12px;
  font-weight: 700;
}

.cca-chip-amount {
  border-color: var(--ion-color-danger, #d83a3a);
  color: var(--ion-color-danger, #d83a3a);
}

.cca-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;
  padding: 14px 16px;
}

.cca-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  padding: 14px;
  border: 1.5px solid #eef0f1;
  border-radius: 16px;
  background: #fff;
  text-align: center;
  cursor: pointer;
  transition: border-color 0.15s ease, box-shadow 0.15s ease, background 0.15s ease;
}
.cca-card.active {
  border-color: var(--ion-color-primary);
  box-shadow: inset 0 0 0 1px var(--ion-color-primary);
  background: #f7fdff;
}

.cca-card-icon {
  width: 44px;
  height: 44px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 4px;
}
.cca-card-icon ion-icon {
  font-size: 22px;
}

.cca-card-title {
  font-size: 14px;
  font-weight: 700;
  color: #2c3033;
}

.cca-card-sub {
  font-size: 11.5px;
  color: #8b9396;
}

.cca-panel {
  margin: 4px 16px 24px;
  padding: 16px;
  border: 1px solid #eef0f1;
  border-radius: 16px;
  background: #fafbfc;
}

.cca-panel-title {
  font-size: 14px;
  font-weight: 700;
  color: var(--ion-color-primary);
  margin-bottom: 12px;
}

.cca-input {
  --background: #fff;
  --padding-start: 12px;
  --padding-end: 12px;
  --color: #2c3033;
  border: 1px solid #dfe3e6;
  border-radius: 10px;
  margin-bottom: 12px;
}

.cca-textarea {
  min-height: 96px;
}

.cca-radio-row {
  display: flex;
  gap: 16px;
  margin-bottom: 8px;
}

.cca-action-btn {
  --background: var(--ion-color-primary);
  --border-radius: 10px;
  --box-shadow: none;
  font-weight: 700;
  text-transform: none;
  margin: 0;
}

.cca-danger {
  --background: var(--ion-color-danger, #d83a3a);
}

.cca-warn {
  font-size: 13px;
  color: #8b9396;
  margin: 0 0 12px;
}

.cca-empty {
  font-size: 13px;
  color: #8b9396;
  text-align: center;
  padding: 12px 0;
}`, "",{"version":3,"sources":["webpack://./src/app/components/cart/cart-actions/cart-actions.component.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EACI,cAAA;EACA,gBAAA;EACA,iCAAA;AAEJ;;AAAE;EACE,iBAAA;EACA,gBAAA;AAGJ;;AADE;EACE,kCAAA;EACA,kBAAA;AAIJ;;AADE;EACE,WAAA;AAIJ;;AAFE;EACE,YAAA;EAEA,yBAAA;EACA,kBAAA;AAIJ;;AADI;EACE,oCAAA;EACA,6BAAA;AAIN;;AADE;EAEE,sBAAA;AAGJ;;AADE;EACE,gCAAA;EACA,eAAA;EACA,gCAAA;AAIJ;;AAFE;EACE,+BAAA;EACA,6BAAA;EACA,6BAAA;EACA,gCAAA;AAKJ;;AAHE;EACE,4BAAA;EACA,gBAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;AAMJ;;AAJE;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,gCAAA;AAOJ;;AALE;EACE,kBAAA;EACA,eAAA;EACA,WAAA;AAQJ;;AAFA;;;0EAAA;AAIA;EACE,kBAAA;EACA,yBAAA;EACA,uBAAA;AAKF;;AAFA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,oBAAA;AAKF;;AAFA;EACE,gBAAA;AAKF;;AAFA;EACE,kBAAA;AAKF;;AAFA;EACE,aAAA;EACA,eAAA;EACA,QAAA;EACA,sBAAA;AAKF;;AAFA;EACE,0CAAA;EACA,+BAAA;EACA,gBAAA;EACA,mBAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;AAKF;;AAFA;EACE,8CAAA;EACA,uCAAA;AAKF;;AAFA;EACE,aAAA;EACA,qCAAA;EACA,SAAA;EACA,kBAAA;AAKF;;AAFA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,QAAA;EACA,aAAA;EACA,2BAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,iFAAA;AAKF;AAFE;EACE,sCAAA;EACA,oDAAA;EACA,mBAAA;AAIJ;;AAAA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;AAGF;AADE;EACE,eAAA;AAGJ;;AACA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AAEF;;AACA;EACE,iBAAA;EACA,cAAA;AAEF;;AACA;EACE,qBAAA;EACA,aAAA;EACA,yBAAA;EACA,mBAAA;EACA,mBAAA;AAEF;;AACA;EACE,eAAA;EACA,gBAAA;EACA,+BAAA;EACA,mBAAA;AAEF;;AACA;EACE,kBAAA;EACA,qBAAA;EACA,mBAAA;EACA,gBAAA;EACA,yBAAA;EACA,mBAAA;EACA,mBAAA;AAEF;;AACA;EACE,gBAAA;AAEF;;AACA;EACE,aAAA;EACA,SAAA;EACA,kBAAA;AAEF;;AACA;EACE,sCAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,oBAAA;EACA,SAAA;AAEF;;AACA;EACE,8CAAA;AAEF;;AACA;EACE,eAAA;EACA,cAAA;EACA,gBAAA;AAEF;;AACA;EACE,eAAA;EACA,cAAA;EACA,kBAAA;EACA,eAAA;AAEF","sourcesContent":[".cartActionSegment {\n    display: block;\n    max-width: 250px;\n    border-right: 1px solid lightgray;\n  }\n  .clsSavedSearches {\n    max-height: 350px;\n    overflow-y: auto;\n  }\n  .clshdr {\n    border-bottom: 1px solid lightgray;\n    margin-bottom: 0px;\n  } \n  \n  .cellTemplateInput {\n    width: 100%;\n  }\n  .filters {\n    height: 100%;\n    // overflow: scroll;\n    background-color: #f5f5f6;\n    padding: 0 0 180px;\n  }\n  ion-row{\n    ion-textarea{\n      border: 1px solid #0099c2 !important;\n      border-radius: 5px !important;\n    }\n }\n  .searchFilters {\n    // position: fixed;\n    margin: 0px !important;\n  }\n  .itemList {\n    --background: #f5f5f6 !important;\n    font-size: 14px;\n    border-bottom: 1px solid #eaeaec;\n  }\n  .noPadding {\n    --padding-start: 0px !important;\n    --padding-end: 0px !important;\n    --padding-top: 0px !important;\n    --padding-bottom: 0px !important;\n  }\n  .filter {\n    padding: 14px 12px 10px 20px;\n    text-align: left;\n    font-weight: 500;\n    height: 50px;\n    font-size: 13px;\n  }\n  .selectedFilter {\n    --background: #fff;\n    font-weight: 500;\n    font-size: 14px;\n    border-bottom: 1px solid #eaeaec;\n  }\n  .headTitle {\n    text-align: center;\n    margin-top: 0px;\n    width: 100%;\n  }\n  .cart-action-header{\n\n  }\n\n/* =====================================================================\n   Cart Actions — card-grid redesign (only the !actionType branch).\n   Colours match the search action sheet; palette preserved via vars.\n   ===================================================================== */\n.cca-header ion-toolbar {\n  --background: #fff;\n  --border-width: 0 0 1px 0;\n  --border-color: #eef0f1;\n}\n\n.cca-title {\n  font-size: 18px;\n  font-weight: 700;\n  color: #2c3033;\n  padding-inline: 16px;\n}\n\n.cca-close {\n  --color: #6b7280;\n}\n\n.cca-content {\n  --background: #fff;\n}\n\n.cca-summary {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  padding: 14px 16px 2px;\n}\n\n.cca-chip {\n  border: 1px solid var(--ion-color-primary);\n  color: var(--ion-color-primary);\n  background: #fff;\n  border-radius: 40px;\n  padding: 4px 12px;\n  font-size: 12px;\n  font-weight: 700;\n}\n\n.cca-chip-amount {\n  border-color: var(--ion-color-danger, #d83a3a);\n  color: var(--ion-color-danger, #d83a3a);\n}\n\n.cca-grid {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 12px;\n  padding: 14px 16px;\n}\n\n.cca-card {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 4px;\n  padding: 14px;\n  border: 1.5px solid #eef0f1;\n  border-radius: 16px;\n  background: #fff;\n  text-align: center;\n  cursor: pointer;\n  transition: border-color 0.15s ease, box-shadow 0.15s ease,\n    background 0.15s ease;\n\n  &.active {\n    border-color: var(--ion-color-primary);\n    box-shadow: inset 0 0 0 1px var(--ion-color-primary);\n    background: #f7fdff;\n  }\n}\n\n.cca-card-icon {\n  width: 44px;\n  height: 44px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 4px;\n\n  ion-icon {\n    font-size: 22px;\n  }\n}\n\n.cca-card-title {\n  font-size: 14px;\n  font-weight: 700;\n  color: #2c3033;\n}\n\n.cca-card-sub {\n  font-size: 11.5px;\n  color: #8b9396;\n}\n\n.cca-panel {\n  margin: 4px 16px 24px;\n  padding: 16px;\n  border: 1px solid #eef0f1;\n  border-radius: 16px;\n  background: #fafbfc;\n}\n\n.cca-panel-title {\n  font-size: 14px;\n  font-weight: 700;\n  color: var(--ion-color-primary);\n  margin-bottom: 12px;\n}\n\n.cca-input {\n  --background: #fff;\n  --padding-start: 12px;\n  --padding-end: 12px;\n  --color: #2c3033;\n  border: 1px solid #dfe3e6;\n  border-radius: 10px;\n  margin-bottom: 12px;\n}\n\n.cca-textarea {\n  min-height: 96px;\n}\n\n.cca-radio-row {\n  display: flex;\n  gap: 16px;\n  margin-bottom: 8px;\n}\n\n.cca-action-btn {\n  --background: var(--ion-color-primary);\n  --border-radius: 10px;\n  --box-shadow: none;\n  font-weight: 700;\n  text-transform: none;\n  margin: 0;\n}\n\n.cca-danger {\n  --background: var(--ion-color-danger, #d83a3a);\n}\n\n.cca-warn {\n  font-size: 13px;\n  color: #8b9396;\n  margin: 0 0 12px;\n}\n\n.cca-empty {\n  font-size: 13px;\n  color: #8b9396;\n  text-align: center;\n  padding: 12px 0;\n}\n\n\n  "],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
